import { Model, Attr } from "spraypaint";
import { ApplicationRecord } from "./ApplicationRecord";

@Model()
export class RequestOnsiteSurvey extends ApplicationRecord {
  static jsonapiType = "request_onsite_surveys";
  @Attr() orderId!: string;
}
